import { forwardRef } from "react";
import type { InputProps } from "./interface";

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, ...props }, ref) => {
    const mergedClassName = [props.className, props.type === "date" ? "date-input" : ""]
      .filter(Boolean)
      .join(" ");

    return (
      <div className="flex flex-col gap-2">
        {label && <label className="font-semibold text-sm">{label}</label>}
        <input
          ref={ref}
          {...props}
          className={`border border-[#D8DCDE] text-sm py-3 px-4 rounded ${props.className} ${mergedClassName}`}
        />
      </div>
    );
  }
);
